module.exports = __webpack_public_path__ + "img/playaAlcudia.b5dc69a1.jpg";